import { createElement } from "react";
import React from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useCtx } from "./Context.jsx";
import { some, unwrap, bind, toArray as toArray_1, map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { append as append_1, map as map_1, tryFind, tryHead } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { UpdatedWorkplace, Workplace as Workplace_1, NewWorkplace } from "./Shared/SharedModels.jsx";
import { Spinner, Card, Caption1, Title3, DataGridCell, DataGridBody, DataGridHeader, DataGridHeaderCell, DataGridRow, DataGrid, createTableColumn as createTableColumn_4, Body1, Body1Strong, tokens, DialogSurface, DialogBody, DialogActions, Switch, Text as Text$, Option, Dropdown, Input, Field, DialogContent, DialogTitle, Button, DialogTrigger, Dialog } from "@fluentui/react-components";
import { equals, createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { FilterRegular, SearchRegular, DismissFilled, CheckmarkFilled, PenDismissRegular, WarningFilled, DeleteRegular, SaveRegular, EditRegular, DismissRegular, AddRegular } from "@fluentui/react-icons";
import { take, length, iterate, toArray, tryHead as tryHead_1, empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { compare, isNullOrWhiteSpace } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { startAsPromise } from "./fable_modules/fable-library-js.4.24.0/Async.js";
import { Region, toastServerError, Workplace } from "./ApiClient.jsx";
import { successToast, errorToast } from "./Toasts.jsx";
import { SortDirection } from "./fable_modules/FS.FluentUI.2.5.2/Domain.fs.js";
import { dataGrid_items_Z6D8BD2B8 } from "./fable_modules/FS.FluentUI.2.5.2/Props2.fs.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";

function AddWorkplaceDialog(addWorkplaceDialogInputProps) {
    let elems_7, el_4, el_2, el, props_54, props_52, el_6, el_27, elems_5, el_11, el_20, matchValue_1, el_17, elems_2, el_25, matchValue_2, el_22, el_37, elems_6, el_31, el_29, el_35, el_33, name_1, name_3, elemsToUse;
    const setWorkplaces = addWorkplaceDialogInputProps.setWorkplaces;
    const workplaces = addWorkplaceDialogInputProps.workplaces;
    const regions = addWorkplaceDialogInputProps.regions;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const setCtx = useCtx()[1];
    let patternInput_3;
    const initial_2 = new NewWorkplace("", true, defaultArg(map((_arg) => _arg.Id, tryHead(regions)), -1));
    patternInput_3 = reactApi.useState(initial_2);
    const setForm = patternInput_3[1];
    const form = patternInput_3[0];
    const resetForm = () => {
        setForm(new NewWorkplace("", true, defaultArg(map((_arg_1) => _arg_1.Id, tryHead(regions)), -1)));
    };
    const el_39 = Dialog;
    return createElement(el_39, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg_2, value_1_2) => {
        setIsOpen(value_1_2.open);
    }], (elems_7 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = AddRegular, createElement(el, {})),
            iconPosition: "before",
            appearance: "primary",
            children: "Legg til",
        })),
    })), (props_54 = singleton_1((props_52 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Legg til arbeidsplass",
    })), (el_27 = DialogContent, createElement(el_27, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5 + "px ",
    }], (elems_5 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append(singleton(["label", "Navn"]), delay(() => append(patternInput_1[0] ? append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue, el_8;
        return singleton(["children", (matchValue = tryHead_1([(el_8 = Input, createElement(el_8, {
            value: form.Name,
            onChange: (_arg_3, value_1_9) => {
                const v = value_1_9;
                setForm(new NewWorkplace(v.value, form.Enabled, form.RegionId));
                patternInput_1[1](isNullOrWhiteSpace(v.value));
            },
        }))]), (matchValue == null) ? defaultOf() : matchValue)]);
    }))))))))), (el_20 = Field, createElement(el_20, {
        label: "Region",
        children: (matchValue_1 = tryHead_1([(el_17 = Dropdown, createElement(el_17, createObj(ofArray([["style", {
            minWidth: 200,
        }], ["value", defaultArg(map((_arg_4) => _arg_4.Name, tryFind((region) => (region.Id === form.RegionId), regions)), "Ingen valgt")], ["selectedOptions", toArray([defaultArg(map((_arg_5) => _arg_5.Name, tryFind((region_1) => (region_1.Id === form.RegionId), regions)), "Ingen valgt")])], ["onOptionSelect", (_arg_6, value_1_13) => {
            iterate((region_2) => {
                setForm(new NewWorkplace(form.Name, form.Enabled, region_2.Id));
            }, toArray_1(bind((name) => tryFind((r_1) => (r_1.Name === name), regions), value_1_13.optionText)));
        }], (elems_2 = toList(delay(() => map_1((region_3) => {
            let elems_1, el_13;
            const el_15 = Option;
            return createElement(el_15, createObj(ofArray([["text", region_3.Name], (elems_1 = [(el_13 = Text$, createElement(el_13, {
                children: region_3.Name,
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
        }, regions))), ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
    })), (el_25 = Field, createElement(el_25, {
        label: "Aktiv",
        children: (matchValue_2 = tryHead_1([(el_22 = Switch, createElement(el_22, {
            checked: form.Enabled,
            onChange: (_arg_7, value_1_17) => {
                setForm(new NewWorkplace(form.Name, value_1_17.checked, form.RegionId));
            },
        }))]), (matchValue_2 == null) ? defaultOf() : matchValue_2),
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])])))), (el_37 = DialogActions, createElement(el_37, createObj(ofArray([["position", "end"], (elems_6 = [(el_31 = Button, createElement(el_31, {
        icon: (el_29 = DismissRegular, createElement(el_29, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_8) => {
            setIsOpen(false);
            resetForm();
        },
    })), (el_35 = Button, createElement(el_35, {
        icon: (el_33 = AddRegular, createElement(el_33, {})),
        appearance: "primary",
        iconPosition: "before",
        onClick: (_arg_9) => {
            setIsOpen(false);
            let pr_1;
            const pr = startAsPromise(Workplace.AddWorkplace(form));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    if (res.fields[0].tag === 0) {
                        errorToast(setCtx, "addWorkplaceRegionNotFound", "Kunne ikke legge til arbeidsplass", "Kunne ikke finne region", undefined);
                    }
                    else {
                        errorToast(setCtx, "addWorkplaceConflict", "Kunne ikke legge til arbeidsplass", "Det finnes allerede en arbeidsplass med dette navnet", undefined);
                    }
                }
                else {
                    const r = res.fields[0];
                    setWorkplaces(append_1([r], workplaces));
                    successToast(setCtx, `addWorkplace${r.Id}Success`, "Suksess", `${r.Name} ble lagt til`);
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
            resetForm();
        },
        disabled: isNullOrWhiteSpace(form.Name) ? true : (form.RegionId < 0),
        children: "Legg til",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])]))))]), (name_1 = DialogBody, createElement(name_1, {
        children: reactApi.Children.toArray(Array.from(props_52)),
    })))), (name_3 = DialogSurface, createElement(name_3, {
        children: reactApi.Children.toArray(Array.from(props_54)),
    })))], (elemsToUse = ((length(elems_7) <= 2) ? elems_7 : take(2, elems_7)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function EditWorkplaceDialog(editWorkplaceDialogInputProps) {
    let elems_8, el_4, el_2, el, props_55, props_53, el_6, el_27, elems_6, elems_1, el_11, el_20, matchValue_1, el_17, elems_3, el_25, matchValue_2, el_22, el_37, elems_7, el_31, el_29, el_35, el_33, name_3, name_5, elemsToUse;
    const setWorkplaces = editWorkplaceDialogInputProps.setWorkplaces;
    const workplaces = editWorkplaceDialogInputProps.workplaces;
    const regions = editWorkplaceDialogInputProps.regions;
    const workplace = editWorkplaceDialogInputProps.workplace;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const setCtx = useCtx()[1];
    const patternInput_2 = reactApi.useState(workplace);
    const setForm = patternInput_2[1];
    const form = patternInput_2[0];
    const dependencies = [workplace];
    reactApi.useEffect(() => {
        setForm(workplace);
    }, dependencies);
    const el_39 = Dialog;
    return createElement(el_39, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg_1, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_8 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = EditRegular, createElement(el, {})),
            appearance: "transparent",
        })),
    })), (props_55 = singleton_1((props_53 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: `Rediger ${workplace.Name}`,
    })), (el_27 = DialogContent, createElement(el_27, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5 + "px ",
    }], (elems_6 = [createElement("div", createObj(ofArray([["style", {
        minHeight: 80,
    }], (elems_1 = [(el_11 = Field, createElement(el_11, createObj(toList(delay(() => append(singleton(["label", "Navn"]), delay(() => append(isNullOrWhiteSpace(form.Name) ? append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
        let matchValue, el_8;
        return singleton(["children", (matchValue = tryHead_1([(el_8 = Input, createElement(el_8, {
            value: form.Name,
            onChange: (_arg_2, value_1_7) => {
                setForm(new Workplace_1(form.Id, value_1_7.value, form.Enabled, form.Region));
            },
        }))]), (matchValue == null) ? defaultOf() : matchValue)]);
    })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (el_20 = Field, createElement(el_20, {
        label: "Region",
        children: (matchValue_1 = tryHead_1([(el_17 = Dropdown, createElement(el_17, createObj(ofArray([["style", {
            minWidth: 200,
        }], ["value", form.Region.Name], ["selectedOptions", toArray([form.Region.Name])], ["onOptionSelect", (_arg_3, value_1_11) => {
            iterate((region) => {
                setForm(new Workplace_1(form.Id, form.Name, form.Enabled, region));
            }, toArray_1(bind((name_2) => tryFind((r_1) => (r_1.Name === name_2), regions), value_1_11.optionText)));
        }], (elems_3 = toList(delay(() => map_1((region_1) => {
            let elems_2, el_13;
            const el_15 = Option;
            return createElement(el_15, createObj(ofArray([["text", region_1.Name], (elems_2 = [(el_13 = Text$, createElement(el_13, {
                children: region_1.Name,
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
        }, regions))), ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
    })), (el_25 = Field, createElement(el_25, {
        label: "Aktiv",
        children: (matchValue_2 = tryHead_1([(el_22 = Switch, createElement(el_22, {
            checked: form.Enabled,
            onChange: (_arg_4, value_1_15) => {
                setForm(new Workplace_1(form.Id, form.Name, value_1_15.checked, form.Region));
            },
        }))]), (matchValue_2 == null) ? defaultOf() : matchValue_2),
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])])))), (el_37 = DialogActions, createElement(el_37, createObj(ofArray([["position", "end"], (elems_7 = [(el_31 = Button, createElement(el_31, {
        icon: (el_29 = DismissRegular, createElement(el_29, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_5) => {
            setIsOpen(false);
            setForm(workplace);
        },
    })), (el_35 = Button, createElement(el_35, {
        icon: (el_33 = SaveRegular, createElement(el_33, {})),
        appearance: "primary",
        iconPosition: "before",
        onClick: (_arg_6) => {
            setIsOpen(false);
            let pr_1;
            const pr = startAsPromise(Workplace.UpdateWorkplace(new UpdatedWorkplace(form.Id, form.Name, form.Enabled, form.Region.Id)));
            pr_1 = (pr.then((res) => {
                if (res.tag === 1) {
                    switch (res.fields[0].tag) {
                        case 0: {
                            errorToast(setCtx, `UpdateWorkplace${workplace.Id}RegionNotFound`, "Kunne ikke oppdatere arbeidsplass", "Kunne ikke finne region", undefined);
                            break;
                        }
                        case 1: {
                            errorToast(setCtx, `UpdateWorkplace${workplace.Id}NotFound`, "Kunne ikke oppdatere arbeidsplass", "Kunne ikke finne arbeidsplass", undefined);
                            break;
                        }
                        default:
                            errorToast(setCtx, `UpdateWorkplace${workplace.Id}Conflict`, "Kunne ikke oppdatere arbeidsplass", "Det finnes allerede en arbeidsplass med dette navnet", undefined);
                    }
                }
                else {
                    const r = res.fields[0];
                    setWorkplaces(map_1((w) => {
                        if (w.Id === r.Id) {
                            return r;
                        }
                        else {
                            return w;
                        }
                    }, workplaces));
                    successToast(setCtx, `updateWorkplace${r.Id}Success`, "Suksess", "Arbeidsplass ble oppdatert");
                }
                return res;
            }));
            void (pr_1.catch((ex) => {
                toastServerError(setCtx, ex);
            }));
        },
        disabled: ((form.Name === workplace.Name) && (form.Enabled === workplace.Enabled)) && equals(form.Region, workplace.Region),
        children: "Lagre endringer",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])]))))]), (name_3 = DialogBody, createElement(name_3, {
        children: reactApi.Children.toArray(Array.from(props_53)),
    })))), (name_5 = DialogSurface, createElement(name_5, {
        children: reactApi.Children.toArray(Array.from(props_55)),
    })))], (elemsToUse = ((length(elems_8) <= 2) ? elems_8 : take(2, elems_8)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function DeleteWorkplaceDialog(deleteWorkplaceDialogInputProps) {
    let elems_3, el_4, el_2, el, props_47, props_45, el_6, el_14, elems, el_20, elems_1, el_18, el_16, el_30, elems_2, name, name_2, elemsToUse;
    const setWorkplaces = deleteWorkplaceDialogInputProps.setWorkplaces;
    const workplaces = deleteWorkplaceDialogInputProps.workplaces;
    const workplace = deleteWorkplaceDialogInputProps.workplace;
    const patternInput = reactApi.useState(false);
    const setIsOpen = patternInput[1];
    const setCtx = useCtx()[1];
    const el_32 = Dialog;
    return createElement(el_32, createObj(ofArray([["open", patternInput[0]], ["onOpenChange", (_arg, value_1_1) => {
        setIsOpen(value_1_1.open);
    }], (elems_3 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = DeleteRegular, createElement(el, {})),
            appearance: "transparent",
        })),
    })), (props_47 = singleton_1((props_45 = ofArray([(el_6 = DialogTitle, createElement(el_6, {
        children: "Er du sikker?",
    })), (el_14 = DialogContent, createElement(el_14, createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 5 + "px ",
        marginBottom: 10,
    }], (elems = toList(delay(() => {
        let el_8;
        return append(singleton((el_8 = WarningFilled, createElement(el_8, {
            primaryFill: tokens.colorStatusWarningForeground1,
            fontSize: 48,
        }))), delay(() => {
            let el_10;
            return append(singleton((el_10 = Body1Strong, createElement(el_10, {
                children: `Er du sikker på at du vil slette ${workplace.Name}? Det vil ikke være mulig å angre denne handlingen.`,
            }))), delay(() => {
                let el_12;
                return workplace.Enabled ? singleton((el_12 = Body1, createElement(el_12, {
                    children: "Du kan alternativt sette arbeidsplassen som inaktiv for å skjule den for brukere.",
                }))) : empty();
            }));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems))])])))), (el_20 = DialogActions, createElement(el_20, createObj(ofArray([["position", "start"], (elems_1 = [(el_18 = Button, createElement(el_18, {
        icon: (el_16 = DismissRegular, createElement(el_16, {})),
        iconPosition: "before",
        children: "Avbryt",
        onClick: (_arg_1) => {
            setIsOpen(false);
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])))), (el_30 = DialogActions, createElement(el_30, createObj(ofArray([["position", "end"], (elems_2 = toList(delay(() => {
        let el_24, el_22;
        return append(workplace.Enabled ? singleton((el_24 = Button, createElement(el_24, {
            icon: (el_22 = PenDismissRegular, createElement(el_22, {})),
            iconPosition: "before",
            children: "Sett inaktiv",
            onClick: (_arg_2) => {
                setIsOpen(false);
                let pr_3;
                const pr_2 = startAsPromise(Workplace.UpdateWorkplace(new UpdatedWorkplace(workplace.Id, workplace.Name, false, workplace.Region.Id)));
                pr_3 = (pr_2.then((res_1) => {
                    if (res_1.tag === 1) {
                        errorToast(setCtx, `DisableWorkplace${workplace.Id}Error`, "Kunne ikke oppdatere arbeidsplass", "Noe gikk galt", undefined);
                    }
                    else {
                        const r = res_1.fields[0];
                        setWorkplaces(map_1((w_1) => {
                            if (w_1.Id === r.Id) {
                                return r;
                            }
                            else {
                                return w_1;
                            }
                        }, workplaces));
                        successToast(setCtx, `disableWorkplace${workplace.Id}Success`, "Suksess", `${workplace.Name} ble satt som inaktiv`);
                    }
                    return res_1;
                }));
                void (pr_3.catch((ex_1) => {
                    toastServerError(setCtx, ex_1);
                }));
            },
        }))) : empty(), delay(() => {
            let el_28, el_26;
            return singleton((el_28 = Button, createElement(el_28, {
                icon: (el_26 = DeleteRegular, createElement(el_26, {})),
                iconPosition: "before",
                appearance: "primary",
                children: "Slett",
                onClick: (_arg_3) => {
                    setIsOpen(false);
                    let pr_1;
                    const pr = startAsPromise(Workplace.DeleteWorkplace(workplace.Id));
                    pr_1 = (pr.then((res) => {
                        if (res.tag === 1) {
                            if (res.fields[0].tag === 0) {
                                errorToast(setCtx, `DeleteWorkplace${workplace.Id}NotFound`, "Kunne ikke slette arbeidsplass", "Noe gikk galt", undefined);
                            }
                            else {
                                errorToast(setCtx, `DeleteWorkplace${workplace.Id}WithUsers`, "Kunne ikke slette arbeidsplass", "Arbeidsplasser som har brukere kan ikke slettes", undefined);
                            }
                        }
                        else {
                            setWorkplaces(workplaces.filter((w) => (w.Id !== workplace.Id)));
                            successToast(setCtx, `deleteWorkplace${workplace.Id}Success`, "Suksess", `${workplace.Name} ble slettet`);
                        }
                        return res;
                    }));
                    void (pr_1.catch((ex) => {
                        toastServerError(setCtx, ex);
                    }));
                },
            })));
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))]), (name = DialogBody, createElement(name, {
        children: reactApi.Children.toArray(Array.from(props_45)),
    })))), (name_2 = DialogSurface, createElement(name_2, {
        children: reactApi.Children.toArray(Array.from(props_47)),
    })))], (elemsToUse = ((length(elems_3) <= 2) ? elems_3 : take(2, elems_3)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

function Table(tableInputProps) {
    let createTableColumn, createTableColumn_1, createTableColumn_2, createTableColumn_3, tupledArg, elems_2, props_12, el_4, name_4, el_10;
    const setWorkplaces = tableInputProps.setWorkplaces;
    const regions = tableInputProps.regions;
    const workplaces = tableInputProps.workplaces;
    const patternInput = reactApi.useState(["name", new SortDirection(1, [])]);
    const columns = ofArray([(createTableColumn = createTableColumn_4, createTableColumn({
        columnId: "name",
        compare: (delegateArg, delegateArg_1) => compare(delegateArg.Name, delegateArg_1.Name),
        renderHeaderCell: () => "Navn",
        renderCell: (delegateArg_3) => delegateArg_3.Name,
    })), (createTableColumn_1 = createTableColumn_4, createTableColumn_1({
        columnId: "enabled",
        compare: (delegateArg_4, delegateArg_1_1) => {
            const a_1 = delegateArg_4;
            const b_1 = delegateArg_1_1;
            if (a_1.Enabled && b_1.Enabled) {
                return 0;
            }
            else if (a_1.Enabled && !b_1.Enabled) {
                return -1;
            }
            else {
                return 1;
            }
        },
        renderHeaderCell: () => "Aktiv",
        renderCell: (delegateArg_6) => {
            if (delegateArg_6.Enabled) {
                const el = CheckmarkFilled;
                return createElement(el, {
                    primaryFill: tokens.colorStatusSuccessForeground1,
                });
            }
            else {
                const el_2 = DismissFilled;
                return createElement(el_2, {
                    primaryFill: tokens.colorStatusDangerForeground1,
                });
            }
        },
    })), (createTableColumn_2 = createTableColumn_4, createTableColumn_2({
        columnId: "region",
        compare: (delegateArg_7, delegateArg_1_2) => compare(delegateArg_7.Region.Name, delegateArg_1_2.Region.Name),
        renderHeaderCell: () => "Region",
        renderCell: (delegateArg_9) => delegateArg_9.Region.Name,
    })), (createTableColumn_3 = createTableColumn_4, createTableColumn_3({
        columnId: "edit",
        renderHeaderCell: () => "",
        renderCell: (delegateArg_11) => {
            let elems;
            const workplace_3 = delegateArg_11;
            return createElement("div", createObj(singleton_1((elems = [createElement(EditWorkplaceDialog, {
                workplace: workplace_3,
                regions: regions,
                workplaces: workplaces,
                setWorkplaces: setWorkplaces,
            }), createElement(DeleteWorkplaceDialog, {
                workplace: workplace_3,
                workplaces: workplaces,
                setWorkplaces: setWorkplaces,
            })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
        },
    }))]);
    const el_12 = DataGrid;
    return createElement(el_12, createObj(ofArray([dataGrid_items_Z6D8BD2B8(workplaces), ["columns", toArray(columns)], ["sortable", true], (tupledArg = patternInput[0], ["sortState", {
        sortColumn: unwrap(tupledArg[0]),
        sortDirection: tupledArg[1],
    }]), ["onSortChange", (delegateArg_12, delegateArg_1_3) => {
        const sortState_1 = delegateArg_1_3;
        patternInput[1]([sortState_1.sortColumn, sortState_1.sortDirection]);
    }], ["getRowId", (delegateArg_13) => delegateArg_13.Id], (elems_2 = [(props_12 = singleton_1((el_4 = DataGridRow, createElement(el_4, {
        children: (delegateArg_14, delegateArg_1_4) => {
            const props_7 = singleton_1(delegateArg_14.renderHeaderCell());
            const name_2 = DataGridHeaderCell;
            return createElement(name_2, {
                children: reactApi.Children.toArray(Array.from(props_7)),
            });
        },
    }))), (name_4 = DataGridHeader, createElement(name_4, {
        children: reactApi.Children.toArray(Array.from(props_12)),
    }))), (el_10 = DataGridBody, createElement(el_10, {
        children: (delegateArg_16) => {
            const trd = delegateArg_16;
            const el_8 = DataGridRow;
            return createElement(el_8, {
                key: trd.rowId,
                children: (delegateArg_15, delegateArg_1_5) => {
                    let elems_1;
                    const tcd_1 = delegateArg_15;
                    const el_6 = DataGridCell;
                    return createElement(el_6, createObj(ofArray([["key", tcd_1.columnId], (elems_1 = [tcd_1.renderCell(trd.item)], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
                },
            });
        },
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
}

export function WorkplaceTable() {
    let elems_4, elems_1, el_16, elems_2, el_10, el_8, el_14, el_12, el_20, elems_3;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState(undefined);
    const workplaces = patternInput_1[0];
    const setWorkplaces = patternInput_1[1];
    const patternInput_2 = reactApi.useState([]);
    const regions = patternInput_2[0];
    useEffectOnce(() => {
        let pr_1;
        const pr = startAsPromise(Workplace.GetAllWorkplaces());
        pr_1 = (pr.then((res) => {
            if (res.tag === 1) {
                errorToast(setCtx, "fetchWorkplacesError", "Noe gikk galt", "Kunne ikke hente arbeidsplasser", undefined);
            }
            else {
                setWorkplaces(res.fields[0]);
            }
            return res;
        }));
        void (pr_1.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
        let pr_3;
        const pr_2 = startAsPromise(Region.GetAllRegions());
        pr_3 = (pr_2.then((res_1) => {
            if (res_1.tag === 1) {
                console.warn(some("Could not fetch regions"));
            }
            else {
                patternInput_2[1](res_1.fields[0]);
            }
            return res_1;
        }));
        void (pr_3.catch((exn) => {
            console.warn(some(`Could not fetch regions: ${exn.message}`));
        }));
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 2 + "rem",
    }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    }], (elems_1 = toList(delay(() => {
        let elems, el, el_2;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
        }], (elems = [(el = Title3, createElement(el, {
            children: "Arbeidsplasser",
        })), (el_2 = Caption1, createElement(el_2, {
            children: "Vis og administrer arbeidsplasser",
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let el_6, el_4;
            const matchValue = workplaces;
            if (matchValue != null) {
                const w = matchValue;
                return singleton(createElement(AddWorkplaceDialog, {
                    regions: regions,
                    workplaces: w,
                    setWorkplaces: (arg) => {
                        setWorkplaces(arg);
                    },
                }));
            }
            else {
                return singleton((el_6 = Button, createElement(el_6, {
                    icon: (el_4 = AddRegular, createElement(el_4, {})),
                    iconPosition: "before",
                    children: "Legg til",
                    appearance: "primary",
                    disabled: true,
                })));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (el_16 = Card, createElement(el_16, createObj(ofArray([["orientation", "horizontal"], ["style", {
        width: 100 + "%",
        display: "flex",
        justifyContent: "space-between",
    }], (elems_2 = [(el_10 = Input, createElement(el_10, {
        contentBefore: (el_8 = SearchRegular, createElement(el_8, {})),
        placeholder: "Søk etter arbeidsplass...",
        disabled: true,
    })), (el_14 = Button, createElement(el_14, {
        disabled: true,
        icon: (el_12 = FilterRegular, createElement(el_12, {})),
        iconPosition: "before",
        children: "Filter",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])))), (el_20 = Card, createElement(el_20, createObj(ofArray([["style", {
        width: 100 + "%",
    }], (elems_3 = toList(delay(() => {
        let el_18;
        if (workplaces != null) {
            const w_1 = workplaces;
            return singleton(createElement(Table, {
                workplaces: w_1,
                regions: regions,
                setWorkplaces: (arg_1) => {
                    setWorkplaces(arg_1);
                },
            }));
        }
        else {
            return singleton((el_18 = Spinner, createElement(el_18, {})));
        }
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

//# sourceMappingURL=Workplaces.jsx.map
